"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import HomeContent from "@/app/HomePage/HomeContent";
import HomeSK from "@/components/ui/skeleton/HomeSK";
export default function HomeClient() {
  const $ = _c(4);
  const [loading, setLoading] = useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const timer = setTimeout(() => setLoading(false), 800);
      return () => clearTimeout(timer);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (loading) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <HomeSK />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HomeContent />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}